import React from "react";
// import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
// import { Helmet } from "react-helmet";
import Routes from "./routes";
import "./App.css";
import "react-ui-kit/build/assets/88i/style.css";
import "react-toastify/dist/ReactToastify.css";
import { store } from "./store";

// const initializeGTAG = () => {
//   return (
//     <Helmet>
//       <script
//         async
//         src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GTAG_ID}`}
//       />
//       <script>
//         {`
//         window.dataLayer = window.dataLayer || [];
//         function gtag(){dataLayer.push(arguments);}
//         gtag('js', new Date());
//         gtag('config', '${process.env.REACT_APP_GTAG_ID}');
//       `}
//       </script>
//     </Helmet>
//   );
// };

const App: React.FC = () => {
  return (
    <Provider store={store}>
      {/* {process.env.REACT_APP_ENV === "prod" && initializeGTAG()} */}
      <Routes />
      {/* <ToastContainer /> */}
    </Provider>
  );
};

export default App;
